import { render, staticRenderFns } from "./date_ellipsis.vue?vue&type=template&id=04eb11d5&scoped=true&"
import script from "./date_ellipsis.vue?vue&type=script&lang=js&"
export * from "./date_ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./date_ellipsis.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./date_ellipsis.vue?vue&type=style&index=1&id=04eb11d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eb11d5",
  null
  
)

export default component.exports